import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { BillingProvider } from "@/context/BillingContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";

import LoginSelect from "@/pages/LoginSelect";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Billing from "@/pages/Billing";
import BillHistory from "@/pages/BillHistory";
import SalesReturn from "@/pages/SalesReturn";
import Purchase from "@/pages/Purchase";
import PurchaseHistory from "@/pages/PurchaseHistory";
import PurchaseReturn from "@/pages/PurchaseReturn";
import Customers from "@/pages/Customers";
import Vendors from "@/pages/Vendors";
import Expenses from "@/pages/Expenses";
import DayBook from "@/pages/DayBook";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import GstSettings from "@/pages/GstSettings";
import Automation from "@/pages/Automation";
import InvoiceTheme from "@/pages/InvoiceTheme";
import Staff from "@/pages/Staff";
import PayoutSettings from "@/pages/PayoutSettings";
import MyPayroll from "@/pages/MyPayroll";
import DetailedInvoice from "@/pages/DetailedInvoice";
import QuotationHistory from "@/pages/QuotationHistory";

function App() {
  return (
    <AuthProvider>
      <BillingProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login/:type" element={<Login />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<ProtectedRoute perm="dashboard"><Dashboard /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute perm="billing"><Billing /></ProtectedRoute>} />
            <Route path="/detailed-invoice" element={<ProtectedRoute perm="billing"><DetailedInvoice /></ProtectedRoute>} />
            <Route path="/quotations" element={<ProtectedRoute perm="quotation"><QuotationHistory /></ProtectedRoute>} />
            <Route path="/bills" element={<ProtectedRoute perm="bill_history"><BillHistory /></ProtectedRoute>} />
            <Route path="/sales-return" element={<ProtectedRoute perm="sales_return"><SalesReturn /></ProtectedRoute>} />
            <Route path="/products" element={<ProtectedRoute perm="products_view"><Products /></ProtectedRoute>} />
            <Route path="/purchase" element={<ProtectedRoute perm="purchase"><Purchase /></ProtectedRoute>} />
            <Route path="/purchase-history" element={<ProtectedRoute perm="purchase_history"><PurchaseHistory /></ProtectedRoute>} />
            <Route path="/purchase-return" element={<ProtectedRoute perm="purchase_return"><PurchaseReturn /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute perm="customers"><Customers /></ProtectedRoute>} />
            <Route path="/vendors" element={<ProtectedRoute perm="vendors"><Vendors /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute perm="expenses"><Expenses /></ProtectedRoute>} />
            <Route path="/daybook" element={<ProtectedRoute perm="daybook"><DayBook /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute perm="reports"><Reports /></ProtectedRoute>} />
            <Route path="/gst" element={<ProtectedRoute perm="gst_compliance"><GstSettings /></ProtectedRoute>} />
            <Route path="/automation" element={<ProtectedRoute perm="reminders"><Automation /></ProtectedRoute>} />
            <Route path="/invoice-theme" element={<ProtectedRoute perm="settings"><InvoiceTheme /></ProtectedRoute>} />
            <Route path="/staff" element={<ProtectedRoute perm="staff"><Staff /></ProtectedRoute>} />
            <Route path="/payout-settings" element={<ProtectedRoute perm="staff_payment"><PayoutSettings /></ProtectedRoute>} />
            <Route path="/my-payroll" element={<ProtectedRoute perm="staff_self"><MyPayroll /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute perm="settings"><Settings /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </BillingProvider>
    </AuthProvider>
  );
}

export default App;
